import { apiPost, apiGet, apiPut, apiDelete } from '../lib/api'

export const RESULT_ADD_START = 'RESULT_ADD_START'
export const RESULT_ADD_SUCCESS = 'RESULT_ADD_SUCCESS'
export const RESULT_ADD_ERROR = 'RESULT_ADD_ERROR'

export const RESULT_LOAD_START = 'RESULT_LOAD_START'
export const RESULT_LOAD_SUCCESS = 'RESULT_LOAD_SUCCESS'
export const RESULT_LOAD_ERROR = 'RESULT_LOAD_ERROR'

export const RESULT_UPDATE_START = 'RESULT_UPDATE_START'
export const RESULT_UPDATE_SUCCESS = 'RESULT_UPDATE_SUCCESS'
export const RESULT_UPDATE_ERROR = 'RESULT_UPDATE_ERROR'

export const RESULT_DELETE_START = 'RESULT_DELETE_START'
export const RESULT_DELETE_SUCCESS = 'RESULT_DELETE_SUCCESS'
export const RESULT_DELETE_ERROR = 'RESULT_DELETE_ERROR'

export const RESULTS_LOAD_START = 'RESULTS_LOAD_START'
export const RESULTS_LOAD_SUCCESS = 'RESULTS_LOAD_SUCCESS'
export const RESULTS_LOAD_ERROR = 'RESULTS_LOAD_ERROR'

export const RESULTS_CLEAR = 'RESULTS_CLEAR'
export const RESULT_CLEAR = 'RESULT_CLEAR'

export const saveResult = (body) => ({ getState, fetch }) => ({
  type: 'RESULT_ADD',
  payload: apiPost({
    fetch,
    endpoint: 'result',
    getState,
    body,
  }),
})

export const loadResult = (id) => ({ getState, fetch }) => ({
  type: 'RESULT_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `result/${id}`,
    getState,
  }),
})

export const updateResult = (id, body) => ({ getState, fetch }) => ({
  type: 'RESULT_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: `result/${id}`,
    getState,
    body,
  }),
})

export const deleteResult = (id) => ({ getState, fetch }) => ({
  type: 'RESULT_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `result/${id}`,
    getState,
  }),
})

export const loadResults = (query) => ({ getState, fetch }) => ({
  type: 'RESULTS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'result',
    getState,
    query,
  }),
})

export const loadResultsByStudent = (id) => ({ getState, fetch }) => ({
  type: 'RESULTS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `result/student/${id}`,
    getState,
  }),
})

export const loadResultsByTest = (id) => ({ getState, fetch }) => ({
  type: 'RESULTS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `result/test/${id}`,
    getState,
  }),
})

export const loadResultsByHomework = (id) => ({ getState, fetch }) => ({
  type: 'RESULTS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `result/homework/${id}`,
    getState,
  }),
})

export const clearResults = () => ({
  type: RESULTS_CLEAR,
})

export const clearResult = () => ({
  type: RESULT_CLEAR,
})



// WEBPACK FOOTER //
// ./src/common/results/actions.js